import * as moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

momentDurationFormatSetup(moment);

export const minutesToHours = minutes => (moment.duration(minutes, "minutes") as any).format("h [hours] m [minutes]", { trim: "all" });

export const getDayFromNow = (date: string, presentAction: string, pastAction: string) => {
    const daysDiff = moment(date).diff(moment().startOf("day"), 'days');
    
    if (daysDiff === 1) {
        return presentAction + ' tomorrow';
    } if (daysDiff === 0) {
        return pastAction + ' today!';
    } if (daysDiff === -1) {
        return pastAction + ' yesterday';
    }

    return moment(date).from(moment().startOf("day"));
}

export const getYear = (date: string) => moment(date).format('YYYY');

export default {
    getDayFromNow,
    minutesToHours
};


// WEBPACK FOOTER //
// ./src/utils/index.ts